const CLAVE_USUARIO = "usuarioSIGEDI";
const CLAVE_TOKEN = "tokenJWT";
const VERSION_SESION = "2";

const seteaCokieFirstStep = (respuesta) => {
  if (!respuesta || typeof respuesta !== "object") {
    console.error("Respuesta inválida al guardar usuario:", respuesta);
    return false;
  }

  const usuario = {
    versionSesion: VERSION_SESION,

    id: respuesta.id ?? null,

    identificacion:
      respuesta.identificacion ??
      respuesta.dni ??
      null,

    dni:
      respuesta.dni ??
      respuesta.identificacion ??
      null,

    nombre: respuesta.nombre ?? "",
    apellido: respuesta.apellido ?? "",

    estado: respuesta.estado ?? null,
    destino: respuesta.destino ?? null,
    sedeID: respuesta.sedeID ?? null,
    nivel: respuesta.nivel ?? null,

    dependenciaNombre:
      respuesta.dependenciaNombre ??
      "",

    funcion: respuesta.funcion ?? "",

    blanqueoContrasena:
      respuesta.blanqueoContrasena ??
      0,

    createdAt: respuesta.createdAt ?? null,
    updatedAt: respuesta.updatedAt ?? null,
  };

  try {
    localStorage.setItem(
      CLAVE_USUARIO,
      JSON.stringify(usuario)
    );

    localStorage.setItem(
      "versionSesionSIGEDI",
      VERSION_SESION
    );

    if (respuesta.token) {
      localStorage.setItem(
        CLAVE_TOKEN,
        respuesta.token
      );
    } else {
      localStorage.removeItem(CLAVE_TOKEN);
    }

    return true;
  } catch (error) {
    console.error(
      "Error guardando usuario:",
      error
    );

    return false;
  }
};

export default seteaCokieFirstStep;